import styled from 'styled-components';
import * as flags from '../images/flags';

const Flag = styled.div`
	width: 16px;
	height: 11px;
	background-image: url(${flags.all});
	background-position: ${props => `${props.flag.x}px ${props.flag.y}px`};
`;
export default Flag;